import { render } from "./bookmarked.vue?vue&type=template&id=f804e912&scoped=true"
import script from "./bookmarked.vue?vue&type=script&lang=js"
export * from "./bookmarked.vue?vue&type=script&lang=js"

import "./bookmarked.vue?vue&type=style&index=0&id=f804e912&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f804e912"]])

export default __exports__